<template>
  <el-aside class="the-aside" :class="opened ? 'the-aside__opened' : ''">

    <el-menu
      @select="goPage"
      class="el-menu-vertical"
      :collapse="!opened"
      :default-active="activeMenu"
      background-color="#383F50"
      text-color="#b3b3b3"
      active-text-color="#fff"
      active-background-color="#fff"
    >
      <el-menu-item v-on:click="setMenuOpened(!opened)" index="panel" class="el-menu-vertical__panel">
        <i :class="opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'"></i>
      </el-menu-item>
      <el-menu-item index="cpanel.questionnaire.list" class="el-menu-vertical__indent">
        <i class="el-icon-notebook-2"></i>
        <span slot="title">Анкеты</span>
      </el-menu-item>
      <el-menu-item index="cpanel.worker.list">
        <i class="el-icon-s-check"></i>
        <span slot="title">Сотрудники</span>
      </el-menu-item>
      <el-menu-item index="cpanel.users.list">
        <i class="el-icon-user-solid"></i>
        <span slot="title">Клиенты</span>
      </el-menu-item>
      <el-menu-item index="cpanel.departments.list">
        <i class="el-icon-s-home"></i>
        <span slot="title">Офисы</span>
      </el-menu-item>
      <el-menu-item index="cpanel.push.list">
        <i class="el-icon-bell"></i>
        <span slot="title">push - уведомления</span>
      </el-menu-item>
      <el-menu-item index="cpanel.tipDay.list">
        <i class="el-icon-chat-dot-square"></i>
        <span slot="title">Совет дня</span>
      </el-menu-item>
      <el-menu-item index="cpanel.news.list">
        <i class="el-icon-news"></i>
        <span slot="title">Новости</span>
      </el-menu-item>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-data-line"></i>
          <span>Статистика</span>
        </template>
        <el-menu-item index="cpanel.statistics.users">
          <i class="el-icon-user-solid"></i>
          <span slot="title">Пользователи</span>
        </el-menu-item><el-menu-item index="cpanel.statistics.light">
        <i class="el-icon-news"></i>
        <span slot="title">Визиты light</span>
      </el-menu-item>
      </el-submenu>
      <el-menu-item index="cpanel.procedure" v-if="debug">
        <i class="el-icon-coin"></i>
        <span slot="title">Процедуры</span>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-s-comment"></i>
          <span>Пуши</span>
        </template>
        <el-menu-item index="cpanel.push.log">
          <span slot="title">Лог</span>
        </el-menu-item>
        <el-menu-item index="cpanel.push.schedule">
        <span slot="title">Рассписание</span>
      </el-menu-item>
      </el-submenu>
      <el-menu-item index="cpanel.light" v-if="debug">
        <i class="el-icon-news"></i>
        <span slot="title">Cкрининг - light</span>
      </el-menu-item>
      <el-menu-item index="cpanel.profile">
        <i class="el-icon-paperclip"></i>
        <span slot="title">Профиль</span>
      </el-menu-item>
      <el-menu-item index="cpanel.logs.list" v-if="debug">
        <i class="el-icon-s-data"></i>
        <span slot="title">Логи</span>
      </el-menu-item>

    </el-menu>
  </el-aside>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'TheAside',
  computed: {
    ...mapState('menu', {
      opened: (state) => state.opened
    }),
    ...mapState('projects', {
      projects: (state) => state.projects
    }),
    ...mapState('menu', {
      other: (state) => state.other
    }),
    debug () {
      // todo попросить Славу сделать нормальную переменную в env
      return (process.env.VUE_APP_ADMIN_API_BASE_URL.indexOf('develop') + 1)
    },
    activeMenu () {
      if (this.$route.name === 'cpanel.posts.list') {
        if (this.$route.params.project != null) {
          return this.$route.name + '.' + this.$route.params.project
        }
      }
      return this.$route.name
    }
  },
  methods: {
    ...mapMutations({
      setOpened: 'menu/SET_OPENED'
    }),
    goPage (index) {
      if (index === 'panel') return
      if (index === this.$route.name) {
        // new Error('Navigation Duplicated')
        return
      }
      this.$router.push({
        name: index
      })
    },
    setMenuOpened (opened) {
      this.setOpened(opened)
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.hide-menu-control {
  background: #3ca080;
  color: #FFF;
  padding: 10px;

  align-items: center;
  height: 40px;
  display: flex;
  margin: 20px auto;

  &:hover {
    background: #379376;
  }

  &__title {
    display: block;
    overflow: hidden;
    width: 60px;
    transition: all .5s;

    &--hidden {
      width: 0;
    }
  }

}

.logo__wrapper {
  overflow-x: hidden;
  white-space: nowrap;
}

.the-aside {
  width: auto !important;
  background-color: #383F50;
  z-index: 9;

  .el-menu {
    border: 0 !important;
  }
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 56px;

  padding: 19px 25px;

  &__wrapper {
    overflow: hidden;
    display: block;
    position: relative;
  }

  &__image {
    height: 18px;
    top: 18px;
    left: 3px;
  }

  span {
    padding: 0 25px;
    color: #fff;
  }
}

.el-menu-vertical {
  &__indent {
    margin-top: 60px;
  }
  &:not(.el-menu--collapse) {
    width: 250px;
    min-height: 400px;
  }
  &__panel {
    padding: 0 22px;
    height: 60px;

    color: rgb(179, 179, 179);
    background-color: rgb(56, 63, 80);
    width: 65px;
    float: right;
  }
}

@media only screen and (max-width: 500px) {
  .the-aside {

    height: 100%;
    width: 100%!important;
    display: none;

    &__opened {
      display: block;
      position: absolute;
    }

  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: auto;
  }

}
</style>
